import { Image } from '@jtnews/shared/news';

import generateImageUrl from './generateImageUrl';
import { getImageSources, ImageSource } from './get-image-sources';

type ImageData = Image & {
  src: string;
  sourceData: ImageSource[];
};

const DESKTOP_IMG_WIDTH = 727;
const DESKTOP_IMG_HEIGHT = 484;
const TABLET_IMG_WIDTH = 859;
const TABLET_IMG_HEIGHT = 574;
const MOBILE_IMG_WIDTH = 599;
const MOBILE_IMG_HEIGHT = 399;

const generateMainImageUrl = (data: Image, maxWidth: number) => {
  const IMG_RATIO = 3 / 2;

  let { width, height } = data;
  width = width > maxWidth ? maxWidth : width;
  const imgRatio = width / height;

  if (imgRatio > IMG_RATIO) {
    width = Math.round(height * IMG_RATIO);
  } else {
    height = Math.round(width / IMG_RATIO);
  }

  return generateImageUrl(data, true, width, height) as string;
};

export const getImageData = (
  image: Image,
  isTablet: boolean,
  isMobile: boolean
): ImageData => {
  let width = DESKTOP_IMG_WIDTH;
  let height = DESKTOP_IMG_HEIGHT;

  if (isMobile) {
    width = MOBILE_IMG_WIDTH;
    height = MOBILE_IMG_HEIGHT;
  }

  if (isTablet) {
    width = TABLET_IMG_WIDTH;
    height = TABLET_IMG_HEIGHT;
  }

  const src = generateMainImageUrl(image, width);

  return {
    ...image,
    width,
    height,
    src,
    sourceData: getImageSources(src)
  };
};
